import { cn } from '@/lib/utils';
import { BillRowVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import ActionCell from './ActionCell';
import AmountCell from './AmountCell';
import LabelCell from './LabelCell';
import ValueCell from './ValueCell';

interface BillRowProps extends React.HTMLAttributes<HTMLDivElement> {
  row: BillRowVm;
  isEditing: boolean;
  /** Ostatni wiersz sekcji nie dostaje linii pod spodem. */
  isLast?: boolean;
  onAction?: (row: BillRowVm) => void;
}

/**
 * Wiersz sekcji: etykieta / wartość / kwota / akcja. Podsiatka, a nie
 * `display: contents`, bo podkreślenie musi być jedną kreską na wierszu —
 * na komórkach rozpadało się na odcinki w odstępach między kolumnami.
 */
const BillRow = ({
  row,
  isEditing,
  isLast = false,
  onAction,
  className,
  ...props
}: BillRowProps) => (
  <div
    className={cn(
      'col-span-full grid grid-cols-subgrid items-center',
      !isLast && 'border-b border-neutral-100',
      className,
    )}
    {...props}
  >
    <LabelCell row={row} />
    <ValueCell row={row} />
    <AmountCell row={row} />
    <ActionCell row={row} isEditing={isEditing} onAction={onAction} />
  </div>
);

export default BillRow;
